/**
 * 這裡只是 axios 實體
 * 實際綁定的服務地址需要依照 env 配置來設定
 */
import axios, { AxiosResponse } from 'axios'
import { QueryClient } from '@tanstack/react-query'
import { Platform } from '@/env'

/** Header 或 Cookie 擴充屬性 */
export enum API_CONST {
  X_SESSION_TOKEN = 'x-session-token',
  X_SESSION_PLATFORM_CODE = 'x-session-platform-code',
  X_LANG = 'x-lang',
  X_TRACE_ID = 'x-trace-id',
}

/** 本站服務 Axios 實體 */
export const AgentAPI = axios.create({
  // baseURL: Platform.API_URL, // dev 用反向代理
  timeout: 20 * 1000,
})

/** Set Headers */
export const setHeaders = (headers: Record<string, string>) => {
  Object.assign(AgentAPI.defaults.headers, headers)
}

/** Query Client */
export const QueryClientInstance = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 1000, // 預設快取
      retryDelay: 5 * 1000, // 預設重新嘗試
      placeholderData: (prev: AxiosResponse) => prev, // 保持上一次的請求，避免彈跳
      refetchOnWindowFocus: false, // 禁用自動重新請求
    },
  },
})
